import React from 'react';
import { IStatNotification, IStatNotificationItem, Toast } from './StatNotification';

interface INotificationsContext {
  notifications: IStatNotificationItem[];
  statNotifications: IStatNotification[];
  toasts: Toast[];
  setNotifications: (notifications: IStatNotificationItem[]) => void;
  setStatNotifications: (statNotifications: IStatNotification[]) => void;
  setToasts: (toasts: Toast[]) => void;
}

const NotificationContext = React.createContext<INotificationsContext>({
  statNotifications: [],
  notifications: [],
  toasts: [],
  setNotifications: (_notifications: IStatNotificationItem[]) => {},
  setStatNotifications: (_statNotifications: IStatNotification[]) => {},
  setToasts: (_toasts: Toast[]) => {},
});

export const NotificationProvider = NotificationContext.Provider;
export const NotificationConsumer = NotificationContext.Consumer;

export default NotificationContext;
